import { type EpgDate } from '$/epg/dates'
import { epgProgramsModel } from '$/epg/programs'
import { type TvChannel } from '@setplex/tria-api'
import { createEvent, sample } from 'effector'
import { LOAD_AHEAD, LOAD_BEHIND } from './index.h'
import { epgDateToRange } from './lib'

// load epg for given channels and date
export const load = createEvent<{ channels: TvChannel[]; date: EpgDate }>()

// load programs
sample({
  clock: load,
  fn: ({ channels, date }) => ({
    channels,
    period: epgDateToRange(date, LOAD_BEHIND, LOAD_AHEAD),
  }),
  target: epgProgramsModel.fetchEpg,
})
